import { checkClientSize, checkJsonExist } from "../../../Utilities";

export const getPrefilledDataObject = (
  prefillData,
  applicationCompany,
  whoOpenAccount,
  parsePhone,
  dataAddress,
  clientCeoName,
  representative
) => {
  return {
    clientProfile: [
      {
        clientProfileType: "CPROF7",
        data: {
          clientTitle: prefillData?.companyTitle || prefillData?.company?.title,
          clientLegalStatus: prefillData?.additionalData?.prdbCode,
          clientRepPosition: prefillData?.managerPosition,
          insSect: prefillData?.additionalData?.institutionalSector,
          clientId: applicationCompany?.code,
          whoOpenAccount: whoOpenAccount,
          mainGroup: prefillData?.additionalData?.mainGroup,
          subGroup: prefillData?.additionalData?.subGroup,
          finrep: prefillData?.additionalData?.finrep,
          pfi: prefillData?.additionalData?.pfi,
          leiCode: prefillData?.additionalData?.leiCode,
          prdbCode: prefillData?.additionalData?.prdbCode,
          naceFull: prefillData?.additionalData?.naceFull,
          clientBirthDate: prefillData?.registrationDate,
          clientEmployeeQty: prefillData?.employees,
          clientFullName: prefillData?.companyTitle || prefillData?.company?.title,
          balAsst: prefillData?.totalAssets,
          amlRulesLeg: 0,
          clientSize: checkClientSize(prefillData?.enterpriseSize)
        }
      }
    ],
    clientPhone: [
      {
        clientPhoneType: "Mob",
        data: {
          clientPhoneNo:
            checkJsonExist(prefillData, "phone") && parsePhone(prefillData.phone) !== "+"
              ? parsePhone(prefillData.phone)
              : checkJsonExist(prefillData, "mobile") && parsePhone(prefillData.mobile) !== "+"
              ? parsePhone(prefillData.mobile)
              : ""
        }
      }
    ],
    clientMail: [
      {
        clientEmailType: "MAILL1",
        data: {
          clientEmail: prefillData?.email
        }
      }
    ],
    clientAddress: [
      {
        addressType: "ADRT2",
        data: dataAddress
      },
      {
        addressType: "ADRT1",
        data: {}
      }
    ],
    clientBasicBusiness: [
      {
        clientBasicBusinessType: "CBBSN1",
        data: {
          clientBasicBusiness: prefillData?.additionalData?.nace,
          yearlyIncome: prefillData?.revenue
        }
      }
    ],
    clientCeo: [
      {
        clientCeoType: "CEOC1",
        data: {
          clientCeoId: prefillData?.managerCode,
          ceoActDoc: prefillData?.representation,
          managerBirthDate: prefillData?.managerBirthDate,
          otherCeoCitizien: 0,
          //clientCeoPhone: checkJsonExist(prefillData, 'mobile') ? parsePhone(prefillData.mobile) : '',
          clientCeoDocIssuePlace: "",
          ...clientCeoName,
          clientCeoDocValidDate:
            whoOpenAccount === 1 ? prefillData?.representative?.document?.dateOfExpiration : "",
          clientCeoDocIssueDate:
            whoOpenAccount === 1 ? prefillData?.representative?.document?.dateOfIssue : "",
          clientCeoIdDocType:
            whoOpenAccount === 1 ? prefillData?.representative?.document?.type : "",
          clientCeoDocNo:
            whoOpenAccount === 1 ? prefillData?.representative?.document?.documentNumber : ""
        }
      }
    ],
    clientRep:
      whoOpenAccount === "CMP1"
        ? []
        : [
            {
              clientRepType: "REPC1",
              data: {
                clientRepName: representative?.firstName,
                clientRepSurname: representative?.lastName,
                clientRepId: representative?.code,
                clientRepBirthDate: representative?.birthDate,
                actDoc: "",
                clientRepMandatNo: "",
                clientRepDocIssuePlace: "",
                clientRepDocValidDate: prefillData?.representative?.document?.dateOfExpiration,
                clientRepDocIssueDate: prefillData?.representative?.document?.dateOfIssue,
                clientRepIdDocType: prefillData?.representative?.document?.type,
                clientRepDocNo: prefillData?.representative?.document?.documentNumber
              }
            }
          ],
    clientTaxPayerCountrys: [
      {
        clientTaxPayerCountryType: "TAXC1",
        data: {
          clientTaxPayerCountry: applicationCompany?.country
            ? applicationCompany.country.substr(0, 2)
            : null,
          clientTaxPayerId: prefillData?.vat
        }
      }
    ],
    clientBusPartner: [
      { clientBusPartnerEmpty: false, }
    ],
    mainCustom: [
      { customerEmpty: false, retail: false, }
    ],
    clientBeneficiaries:
      prefillData?.beneficiaries?.length > 0
        ? prefillData.beneficiaries.map((item, index) => {
            return {
              clientBenefType: `BENEF${index + 1}`,
              data: {
                clientBenefName: item?.name,
                clientBenefSurname: item?.surname,
                clientBenefShare: item?.shares
              }
            };
          })
        : [
            {
              clientBenefType: `BENEF1`,
              data: {}
            }
          ]
  };
};
